import axios from "axios";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { Abonnement, ExceptionMusique } from "../../Models/Abonnement/AbonnementModels";
import { errorService } from "../Error/ErrorService";
import { PackService } from "./PackService";
import dayjs from "dayjs";
import { FluxService } from "../Message/FluxService";
import { MagasinService } from "../Magasin/MagasinService";
import { Flux } from "../../Models/Message/MessageModels";
import { Magasin } from "../../Models/Magasin/MagasinModels";

export function AbonnementService(){
    return {

        async getAbonnements(token:string){
            let abonnements:Abonnement[]=[];
            try {
                const response = await axios.get(`${URLAPI+'abonnements'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                for(const abo of data){
                    abonnements.push({
                        id:abo['id'],
                        "@id":abo['@id'],
                        nom:abo['nom'],
                        fluxes:abo['fluxes'],
                        optionsAbonnement:abo['optionsAbonnement'],
                        pack:abo['pack'],
                        souscription:abo['souscription'],
                        magasin:abo['magasin'],
                        exceptionsMusique:abo['exceptionsMusique']
                    })
                }
            } catch (error) {
                return [];
            }
            return abonnements;
        },

        async getAbonnementsAvecMagasin(magasins:Magasin[],token:string){
            let abonnements:Abonnement[]=[];
            try {
                const response = await axios.get(`${URLAPI+'abonnements'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                for(const abo of data){
                    // const [magasin] = await Promise.all([
                    //     MagasinService().getMagasinFromUrlToPromiseToAnything(abo['magasin'], token)
                    // ])
                    abonnements.push({
                        id:abo['id'],
                        "@id":abo['@id'],
                        nom:abo['nom'],
                        fluxes:abo['fluxes'],
                        optionsAbonnement:abo['optionsAbonnement'],
                        pack:abo['pack'],
                        souscription:abo['souscription'],
                        magasin:abo['magasin'],
                        exceptionsMusique:abo['exceptionsMusique']
                    })
                }

                const packs = (await PackService().getPacksUser(token)).data;
                for(const abo of abonnements){
                    const magAbo = magasins.find(mag=>mag.abonnements.find(aboMag=>aboMag["@id"]===abo["@id"]));
                    if(magAbo)abo.magasin=magAbo;
                    const packAbo = packs.find(pack=>pack.abonnements?.find(aboPack=>aboPack["@id"]===abo["@id"]));
                    if(packAbo)abo.pack=packAbo;
                }

            } catch (error) {
                return [];
            }
            return abonnements;
        },

        /**
         * Cette méthode permet de renvoyer un objet Abonnement, rataché à un magasin, via une URL.
         * Pour éviter toute boucle infini via la relation entre un abonnement et son/ses magasin(s),
         * il est préférable de ne pas enregistrer la valeur lié à magasin, ni de la transformer en objet Magasin. 
         * Donc celle-ci restera un objet Magasin|undefined, qui ici sera undefined. (Modification possible à l'avenir).
         * 
         * Si vous souhaitez accèder au magasin à partir de l'objet magasin, alors employez la méthode ???
         */
        async getAbonnementFromUrlToPromiseToMagasin(url:string, token:string):Promise<Abonnement>{
        
            try {
        
            const response = await axios.get(`${URL_MIDIS+url}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":"application/ld+json"
                },
            });
            const data = response.data['hydra:member'];
            // console.log('data abonnement: ', data);
        
            let abonnement : Abonnement = {
                id: data[0]['id'],
                nom: data[0]['nom'],
                fluxes: data[0]['fluxes'],
                pack: data[0]['pack'] ? await PackService().getPackFromUrlToPromiseToAbonnement(data[0]['pack'], token) : undefined,
                actif: data[0]['actif'],
                exceptionsMusique:data[0]['exceptionsMusique'],
                optionsAbonnement:data[0]['optionsAbonnement']
            };
            // console.log('abonnement: ', abonnement);
            return abonnement;
            } catch (error) {
            errorService().handleError('Erreur lors du getAbonnement', error)
            let abonnement : Abonnement = {
                id: 0,
                nom: "",
                fluxes: [],
                pack: undefined,
                actif: false,
                exceptionsMusique:[],
                optionsAbonnement:[]
            };
        
            return abonnement;
            }
        },

        async getAbonnementFromUrlToPromiseToFlux(url:string, token:string):Promise<Abonnement>{
        
            try {
        
            const response = await axios.get(`${URL_MIDIS+url}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":"application/ld+json"
                },
            });
            const data = response.data['hydra:member'];

            // const [magasin] = await Promise.all([
            //     MagasinService().getMagasinFromUrlToPromiseToAnything(data[0]['magasin'], token)
            // ]);
        
            let abonnement : Abonnement = {
                id: data[0]['id'],
                '@id':data[0]['@id'],
                nom: data[0]['nom'],
                fluxes: data[0]['fluxes'],
                pack: data[0]['pack'],
                exceptionsMusique: data[0]['exceptionsMusique'],
                magasin:data[0]['magasin'],
                optionsAbonnement:data[0]['optionsAbonnement']
            };
            return abonnement;
            } catch (error) {
            errorService().handleError('Erreur lors du getAbonnement', error)
            let abonnement : Abonnement = {
                id: 0,
                nom: "",
                fluxes: [],
                exceptionsMusique:[],
                pack: undefined,
                actif: false,
                optionsAbonnement:[]
            };
        
            return abonnement;
            }
        },

        async postAbonnement(idMagasin:number, numContrat:string|undefined, flux1:Flux, flux2:Flux, idPack:number|undefined, dateSouscription:Date|undefined, compteServeur:string, exceptionsMusique:ExceptionMusique[], token:string){
            try {
               //creation abonnement

            if(!idPack || !numContrat || !dateSouscription){
                throw new Error('Pack, Nom du contrat ou date de souscription non défini');
            }

            //création tableau de flux

            //formattage de la date
            const dateFormate = dayjs(dateSouscription).format('YYYY-MM-DD');

            const postAbonnementObject={
                "nom": numContrat,
                "pack": idPack,
                "souscription":dateFormate,
                "fluxes": [],
                "magasin":idMagasin,
                "exceptionsMusique":exceptionsMusique.map(exc=>exc.id),
            }

            const responsePOSTAbonnement = await axios.post(
                `${URLAPI+'abonnement'}`,
                postAbonnementObject,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/ld+json',
                    },
                }
            );
            const abonnementResponseId = responsePOSTAbonnement.data['id'];
            if(responsePOSTAbonnement.status===201){
                //création flux lié à abonnement
                if(!/^\s*$/.test(flux1.nom))await FluxService().postFluxAdminMagasin(flux1.nom, abonnementResponseId, compteServeur, token);
                if(!/^\s*$/.test(flux2.nom))await FluxService().postFluxAdminMagasin(flux2.nom, abonnementResponseId, compteServeur, token);
            }
            return {id:abonnementResponseId, status:responsePOSTAbonnement.status}; 
            } catch (error) {
                errorService().handleError("Erreur lors de l'ajout d'un flux", error)
                return {id:-1, status:400};
            }
        },

        async patchAbonnement(abonnement:Abonnement, flux1:Flux, flux2:Flux, compteServeur:string, token:string){
            if(!abonnement.pack || !abonnement.souscription){
                throw new Error('Pack ou date de souscription non défini');
            }

            //patch des fluxs si compte serveur associés après coup
            if(!/^\s*$/.test(flux1.nom) && flux1.id>0)await FluxService().patchFluxAdminMagasin(flux1.id, flux1.nom, abonnement.id, compteServeur, token);
            if(!/^\s*$/.test(flux2.nom) && flux2.id>0)await FluxService().patchFluxAdminMagasin(flux2.id, flux2.nom, abonnement.id, compteServeur, token);

            //gestion cas ajout flux lors de modif abonnement
            if(!/^\s*$/.test(flux1.nom) && flux1.id<=0)await FluxService().postFluxAdminMagasin(flux1.nom, abonnement.id, compteServeur, token);
            if(!/^\s*$/.test(flux2.nom) && flux2.id<=0)await FluxService().postFluxAdminMagasin(flux2.nom, abonnement.id, compteServeur, token);
            
            //gestion cas suppression flux lors de modif abonnement (uniquement sur flux n°2)
            if(/^\s*$/.test(flux2.nom) && flux2.id>0)await FluxService().deleteFlux(flux2.id, token);

            //formattage de la date
            const dateFormatte = dayjs(abonnement.souscription).format('YYYY-MM-DD');

            let patchAbonnementObject={
                "nom": abonnement.nom,
                "pack": abonnement.pack.id,
                "souscription":dateFormatte,
                // "fluxes":abonnement.fluxes.map(flux=>flux.id),
                "exceptionsMusique":abonnement.exceptionsMusique.map(exc=>exc.id),
            }

            const responsePATCHAbonnement = await axios.patch(
                `${URLAPI+'abonnement/'+abonnement.id}`,
                patchAbonnementObject,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/ld+json',
                    },
                }
            );
            return responsePATCHAbonnement.status;
        },

        async deleteAbonnement(idAbonnement:number, token:string){
            const responseDELETEAbonnement = await axios.delete(
                `${URLAPI+'abonnement/'+idAbonnement}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return responseDELETEAbonnement.status
        }

    }
}